// extracted by mini-css-extract-plugin
export var readonly = "_hh-1";
export var star = "_hh-0";